var map = {
	"./banquet.svg": 289,
	"./banquet_distance.svg": 290,
	"./boardroom.svg": 291,
	"./boardroom_distance.svg": 292,
	"./circle.svg": 293,
	"./circle_distance.svg": 294,
	"./classroom.svg": 295,
	"./classroom_distance.svg": 296,
	"./mingle.svg": 297,
	"./mingle_distance.svg": 298,
	"./no_seating.svg": 299,
	"./on_site_furniture.svg": 300,
	"./on_site_furniture_distance.svg": 301,
	"./seating_rows.svg": 302,
	"./seating_rows_distance.svg": 303,
	"./u-shape.svg": 304,
	"./u-shape_distance.svg": 305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;